module.exports = __webpack_public_path__ + "media/images/custom_page/bae173/top-a70424ea6d0c116b82dd2e7262a0758c.png";